import * as React from "react";
import { Avatar, Button, Flex, Image, Label, Segment, Table, Text, TextArea } from "@fluentui/react-northstar";
import { StarIcon, OpenOutsideIcon } from '@fluentui/react-icons-northstar';
import { withTranslation, WithTranslation } from "react-i18next";
import PesquisaSatisfacaoConstants from '../../../constants/pesquisa-satisfacao';
import { CommonHelper } from '../../../helpers/common-helper';
const _ = require('lodash');

interface IQueueEndedProps extends WithTranslation {
    botWriting1: boolean;
    appConfigs: any;
    appSettings: any;
    meetingData: any;
    meetingQueueData: any;
    ratingSent: boolean;
    rate: number;
    rateLabel: string;
    setRating: any;
    sendRating: any;
    ratingQuestions: any;
    onCommentChange: any;
    onQuestionChanged: any;
    sendCustomRating: any;
    mounted?: boolean;
}

const QueueEndedCard: React.FunctionComponent<IQueueEndedProps> = props => {
    const localize = props.t;

    function renderSectionRatingQuestions(item: any, index: number) {
        return (
            <React.Fragment>
                <Flex gap="gap.smaller">
                    <Text styles={{ margin: '1.5rem 0 0.5rem 0 !important', fontWeight: 'bold' }} weight="light" size="medium" content={item.title} />
                </Flex>
                <Table header={renderHeaderRatingQuestions(item.headers)} rows={renderRatingQuestions(item.questions, index)} />
            </React.Fragment>
        )
    }

    function renderHeaderRatingQuestions(headers: any) {
        const headerRatingQuestions = {
            key: "header",
            styles: { height: "2.8rem !important" },
            items: [
                {
                    content: "",
                    key: "id",
                    styles: { flex: "0 0 40%", alignItems: "center", justifyContent: "center" }
                }
            ]
        };

        headers.map((header: any, index: number) => {
            headerRatingQuestions.items.push(
                {
                    content: header.title,
                    key: header.title,
                    styles: { flex: "1", alignItems: "center", justifyContent: "center" }
                }
            );
        });

        return headerRatingQuestions;
    }

    function renderRatingQuestions(questions: any, indexSession: number) {
        var ratingQuestions: any[] = [];

        questions.map((question: any, index: number) => {
            var itemQuestion = {
                key: questions.id,
                styles: { height: "100% !important", padding: "0.5rem !important", backgroundColor: "rgb(243, 242, 241)" },
                items: [
                    {
                        content: question.questionText,
                        key: `question-${question.id}`,
                        styles: { flex: "0 0 40%", alignItems: "left", justifyContent: "center" }

                    }
                ]
            }

            question.options.map((option: any, index: number) => {
                itemQuestion.items.push(
                    {
                        content: <input type="radio" id={option.id} value={option.text} name={`pergunta-${indexSession}-${question.id}`} className={`${indexSession}-${question.id}`} onChange={props.onQuestionChanged} />,
                        key: `${question.id}-${(index + 1)}`,
                        styles: { flex: "1", alignItems: "center", justifyContent: "center" }
                    }
                );
            });

            ratingQuestions.push(itemQuestion)
        });

        return ratingQuestions;
    }

    return (
        <React.Fragment>
            {((props.appSettings &&
                (props.appSettings.pesquisaSatisfacao == PesquisaSatisfacaoConstants.nenhuma || props.appSettings.pesquisaSatisfacao == null)) ||
                !props.appSettings.length) &&
                <Flex className="card" gap="gap.medium" styles={{ margin: "4rem 0" }}>
                    <img className="logoIcon" src="https://studio365cdn.azureedge.net/balcaovirtual/logov2.svg" />
                    <Flex.Item grow>
                        <Segment
                            hidden={props.botWriting1}
                            className="dialog2 dialog"
                            content={
                                <Flex gap="gap.large" column>
                                    <Text className="header-text" content={`${localize("AtendimentoEncerrado")}!`} />
                                    {props.meetingQueueData?.additionalData?.nrProcesso ?
                                        <span className="header-subtext">{localize('ProcessoAtendimento')} <span className="highlight">{props.meetingQueueData?.additionalData?.nrProcesso}</span></span>
                                        :
                                        <span className="header-subtext">{localize('ProtocoloAtendimento')} <span className="highlight">#{props.meetingQueueData.id.substr(props.meetingQueueData.id?.length - 6)}</span></span>
                                    }

                                    <Flex>
                                        <Flex fill column>
                                            <Label
                                                className="endLabel"
                                                content={(
                                                    <Flex gap="gap.medium" padding="padding.medium" column>
                                                        <Text align="center" weight="light" size="medium" content={localize("AtendimentoConcluido")} />
                                                    </Flex>
                                                )}
                                            />
                                        </Flex>
                                        <Flex hAlign="center">
                                            {props.appConfigs && props.appConfigs.imgEnd != "" &&
                                                <Flex.Item align="center" className="welcome">
                                                    <Image src={props.appConfigs.imgEnd} />
                                                </Flex.Item>
                                            }

                                            {props.appConfigs && props.appConfigs.imgEnd == "" &&
                                                <Flex.Item align="end" className="fila">
                                                    <Image src="https://studio365cdn.azureedge.net/balcaovirtual/fim.svg" className="filaImg" />
                                                </Flex.Item>
                                            }
                                        </Flex>
                                    </Flex>

                                    <Flex gap="gap.small">
                                        {props.appSettings && props.appSettings.ajudaComoFunciona &&
                                            <Button content={localize("ComoFunciona")} secondary onClick={() => window.open(CommonHelper.checkIfContainHttps(props.appSettings.ajudaComoFunciona), "_blank")} />
                                        }

                                        {props.appSettings && props.appSettings.ajudaPerguntasFrequentes &&
                                            <Button content={localize("PerguntasFrequentes")} secondary onClick={() => window.open(CommonHelper.checkIfContainHttps(props.appSettings.ajudaPerguntasFrequentes), "_blank")} />
                                        }
                                    </Flex>
                                </Flex>
                            }
                        />
                    </Flex.Item>
                </Flex>
            }

            {props.appSettings && props.appSettings.pesquisaSatisfacao == PesquisaSatisfacaoConstants.classificacaoAtendimento && !props.mounted &&
                <Flex className="card" gap="gap.medium" styles={{ margin: "4rem 0" }}>
                    <img className="logoIcon" src="https://studio365cdn.azureedge.net/balcaovirtual/logov2.svg" />
                    <Flex.Item grow>
                        <Segment
                            hidden={props.botWriting1}
                            className="dialog2 dialog"
                            content={
                                <Flex gap="gap.large" column>
                                    <Text className="header-text" content={localize("Obrigado")} />

                                    <Flex gap="gap.large">
                                        <Flex className="rating-wrapper" gap="gap.large" fill column>
                                            <Flex hidden={props.ratingSent} column>
                                                <Flex gap="gap.smaller" column>
                                                    <Text styles={{ marginRight: '0.4rem !important' }} weight="light" size="medium" content={localize("AjudeMelhorar")} />
                                                    <Text styles={{ marginRight: '0.4rem !important' }} weight="light" size="medium" content={localize("ComoVoceAvalia")} />
                                                </Flex>
                                            </Flex>

                                            <Flex hidden={props.ratingSent} gap="gap.small">
                                                <Flex.Item size="size.quarter">
                                                    <Segment className="ratingBox">
                                                        <StarIcon size="large" className="rating" outline={props.rate < 1} onClick={() => props.setRating(1)} />
                                                        <StarIcon size="large" className="rating" outline={props.rate < 2} onClick={() => props.setRating(2)} />
                                                        <StarIcon size="large" className="rating" outline={props.rate < 3} onClick={() => props.setRating(3)} />
                                                        <StarIcon size="large" className="rating" outline={props.rate < 4} onClick={() => props.setRating(4)} />
                                                        <StarIcon size="large" className="rating" outline={props.rate < 5} onClick={() => props.setRating(5)} />
                                                    </Segment>
                                                </Flex.Item>
                                                <Flex vAlign="center">
                                                    <Text className={`highlight ${props.rateLabel != "" ? "rate-label" : "" }`} content={props.rateLabel} />
                                                </Flex>
                                            </Flex>

                                            <Flex hidden={props.ratingSent} gap="gap.small" column>
                                                <Text weight="light" size="small" content={localize("Comentarios")} />
                                                <TextArea styles={{ minHeight: '60px' }} onChange={props.onCommentChange} disabled={!_.isEmpty(props.meetingQueueData.rating)} fluid />
                                                <Button
                                                    className="ratingButton"
                                                    content={localize("EnviarResposta")}
                                                    onClick={() => props.sendRating()}
                                                    fluid
                                                    primary
                                                />
                                            </Flex>

                                            <Flex hidden={!props.ratingSent} column>
                                                <Flex gap="gap.smaller" column>
                                                    <Text weight="light" size="medium" content={localize("PesquisaEnviada")} />
                                                </Flex>
                                            </Flex>
                                        </Flex>

                                        <Flex hAlign="center">
                                            {props.i18n.language.includes("es") &&
                                                <Image src="https://studio365cdn.azureedge.net/balcaovirtual/gracias.svg" />
                                            }

                                            {props.i18n.language.includes("pt") &&
                                                <Flex.Item align="start" className="fila">
                                                    <Image src="https://studio365cdn.azureedge.net/balcaovirtual/obrigado.svg" className="filaImg" />
                                                </Flex.Item>
                                            }
                                        </Flex>
                                    </Flex>
                                </Flex>
                            }
                        />
                    </Flex.Item>
                </Flex>
            }


            {props.appSettings && props.appSettings.pesquisaSatisfacao == PesquisaSatisfacaoConstants.pesquisaExterna && !props.mounted &&
                <Flex gap="gap.large" styles={{ margin: "4rem 0" }}>
                    <Avatar icon={<Image src="https://studio365cdn.azureedge.net/balcaovirtual/logo.png" />} />
                    <Flex.Item grow>
                        <Segment
                            hidden={props.botWriting1}
                            className="dialog2"
                            color="brand"
                            content={
                                <Flex gap="gap.large" column>
                                    <Text weight="bold" size="large" content={localize("Obrigado")} />

                                    <Flex hAlign="center">
                                        <Flex.Item align="center" className="welcome">
                                            <React.Fragment>
                                                {props.i18n.language.includes("es") &&
                                                    <Image src="https://studio365cdn.azureedge.net/balcaovirtual/gracias.svg" />
                                                }

                                                {props.i18n.language.includes("pt") &&
                                                    <Image src="https://studio365cdn.azureedge.net/balcaovirtual/obrigado.svg" />
                                                }
                                            </React.Fragment>
                                        </Flex.Item>
                                    </Flex>

                                    <Flex column>
                                        <Flex gap="gap.smaller" column>
                                            <Text styles={{ marginRight: '0.4rem !important' }} weight="light" size="medium" content={localize("AjudeMelhorar")} />
                                        </Flex>
                                    </Flex>

                                    <Flex gap="gap.small">
                                        <Button
                                            content={localize("EnviarReposta")}
                                            icon={<OpenOutsideIcon size="small" outline />}
                                            iconPosition="after"
                                            primary
                                            onClick={() => window.open(CommonHelper.checkIfContainHttps(props.appSettings.urlPesquisaSatisfacaoExterna), "_blank")}
                                        />
                                    </Flex>
                                </Flex>
                            }
                        />
                    </Flex.Item>
                </Flex>
            }

            {props.appSettings && props.appSettings.pesquisaSatisfacao == PesquisaSatisfacaoConstants.pesquisaCustomizada && props.appConfigs && props.appConfigs.ratingQuestions && !props.mounted &&
                <Flex gap="gap.large" styles={{ margin: "4rem 0" }}>
                    <Avatar icon={<Image src="https://studio365cdn.azureedge.net/balcaovirtual/logo.png" />} />
                    <Flex.Item grow>
                        <Segment
                            hidden={props.botWriting1}
                            className="dialog2"
                            color="brand"
                            content={
                                <Flex gap="gap.large" column>
                                    <Text weight="bold" size="large" content={localize("Obrigado")} />

                                    <Flex hAlign="center">
                                        <Flex.Item align="center" className="welcome">
                                            <React.Fragment>
                                                {props.i18n.language.includes("es") &&
                                                    <Image src="https://studio365cdn.azureedge.net/balcaovirtual/gracias.svg" />
                                                }

                                                {props.i18n.language.includes("pt") &&
                                                    <Image src="https://studio365cdn.azureedge.net/balcaovirtual/obrigado.svg" />
                                                }
                                            </React.Fragment>
                                        </Flex.Item>
                                    </Flex>

                                    <Flex hidden={props.ratingSent} styles={{ marginBottom: '0px !important' }} column>
                                        <Flex gap="gap.smaller" column>
                                            <Text styles={{ marginRight: '0.4rem !important' }} weight="light" size="medium" content={localize("AjudeMelhorar")} />
                                        </Flex>
                                    </Flex>

                                    <Flex hidden={props.ratingSent} gap="gap.small">
                                        <Flex.Item size="size.quarter">
                                            <Segment className="ratingBoxCustom">
                                                {props.ratingQuestions.data.sessions.map(renderSectionRatingQuestions)}
                                            </Segment>
                                        </Flex.Item>
                                    </Flex>

                                    <Flex hidden={props.ratingSent} gap="gap.small">
                                        <Button
                                            className="ratingButton"
                                            content={localize("EnviarReposta")}
                                            onClick={props.sendCustomRating}
                                            primary
                                        />
                                    </Flex>

                                    <Flex hidden={!props.ratingSent} column>
                                        <Flex gap="gap.smaller" column>
                                            <Text weight="light" size="medium" content={localize("PesquisaEnviada")} />
                                        </Flex>
                                    </Flex>
                                </Flex>
                            }
                        />
                    </Flex.Item>
                </Flex>
            }
        </React.Fragment>
    );
};

const queueEndedWithTranslation = withTranslation()(QueueEndedCard);
export default queueEndedWithTranslation;